import { DateTitle } from 'Shared/frontend/PosterTitle';
import { css, cx } from '@emotion/css';
import { fonts, poster} from 'Shared/frontend/SettingsProvider';


/* flexShrink because the poster is a flex item in the carousel and grid layouts, and its own
   'overflow:hidden' zeroes the automatic minimum size a flex item would otherwise get - without
   this the posters are squeezed well under their width and their right hand sides are cropped. */
const posterStyle = (theme:string) => css(poster(theme).root,{
	overflow: 'hidden',
	flexShrink: 0,
});

const dateStyle = (theme:string) => css({
	fontFamily: fonts().heading,
	width: '100%',
	padding: '0.5em',
	textTransform: 'uppercase',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	// changed from set height to allow for 2nd line for Monthly dates, it will push uploaded poster down
	minHeight: 43.2,
	...poster(theme).dateBar,
});

export const nameStyle = (theme:string) => css(poster(theme).name,{
	fontFamily: fonts().text,
});

export const eventTaglineStyle = (theme:string) => css(poster(theme).eventTagline,{
	fontFamily: fonts().text,
	lineHeight: '1.2em',
	textAlign: 'center',
	
});


export function Poster(P:{children,theme:string})
{
	return (
		<div class={cx('capture',posterStyle(P.theme))}>
			{ P.children }
		</div>
	);
}

export function DateWrap(P)
{
	const dateWrapStyle = css({
		width: 'inherit',
		height: 'inherit',
		display: 'flex !important',
		flexDirection: 'column',
		alignItems: 'stretch',
	});

	return (
		<div class={dateWrapStyle}>
			<div class={dateStyle(P.posterSettings.theme)}>
				{P.times.customLabel ?? <DateTitle {...P.times}/> }
			</div>

			{ P.children }
		</div>
	);
}

export function maxTextLines(maxLines:number) 
{
	/* 
		In time should be able to use unprefixed line-clamp. 
		See: https://caniuse.com/?search=line-clamp for progress 
	*/
	const limitProperties = maxLines==1 ? { whiteSpace: 'nowrap' } : {
		display: '-webkit-box',
		WebkitBoxOrient: 'vertical',
		WebkitLineClamp: `${maxLines}`
	};

	return {
		...limitProperties,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	};
}

